<button
	matButton
	[matButton]="materialAppearance()"
	[type]="type()"
	[disabled]="isDisabled()"
	[attr.aria-label]="computedAriaLabel()"
	class="btn"
	[class.btn-primary]="variant() === 'primary'"
	[class.btn-secondary]="variant() === 'secondary'"
	[class.btn-small]="size() === 'small'"
	(click)="onClick($event)"
>
	@if (!loading() && icon()) {
		<mat-icon class="material-symbols-outlined" aria-hidden="true">
			{{ icon() }}
		</mat-icon>
	}

	@if (loading()) {
		@if (loadingLabel()) {
			{{ loadingLabel() }}
		} @else {
			<mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
		}
	} @else {
		{{ label() }}
	}
</button>
